import { ApiLambdalerAuthHeaderWithRequestActorSchema } from '@eigtech/lambdaler-api-gateway-types';
import { z } from 'zod';
import { InspectionCornSchema, InspectionEntityCornSchema } from '../base.js';
import { InspectionCompletionProcessingSchema } from '../entities/inspectionCompletionProcessing.js';
export const RetryInspectionCompletionProcessingApiSchema = {
    params: z.object({
        entityId: InspectionEntityCornSchema,
        inspectionId: InspectionCornSchema,
    }),
    headers: ApiLambdalerAuthHeaderWithRequestActorSchema,
    response: InspectionCompletionProcessingSchema,
};
export const RetryInspectionCompletionProcessingRequestSchema = RetryInspectionCompletionProcessingApiSchema.params.merge(RetryInspectionCompletionProcessingApiSchema.headers);
